import { default as Perfil } from './Perfil';
import * as Acesso from './Acesso';
import * as Organizacao from './Organizacao';

export default {
  Perfil,
  Acesso,
  Organizacao,
};
